<template>
  <section>
    <!-- autenticacao-->
    <CCard :ref="pageSections.APIKey">
      <CCardHeader class="">
        <h2 class="mb-2" ref="transactional-api-authentication">{{ $t('api.documentation.api-key.titlePage') }}</h2>
      </CCardHeader>

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.api-key.001.title') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <p>{{ $t('api.documentation.api-key.001.paragraph') }}</p>

        <ul>
          <li>
            {{ $t('api.documentation.api-key.001.list.001') }}
            <ul>
              <li>{{ $t('api.documentation.api-key.001.list.001-1') }}</li>
            </ul>
          </li>
          <li>
            {{ $t('api.documentation.api-key.001.list.002') }}
            <ul>
              <li>{{ $t('api.documentation.api-key.001.list.002-1') }}</li>
            </ul>
          </li>
        </ul>
      </CCardBody>

      <hr />

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.api-key.002.title') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <p>{{ $t('api.documentation.api-key.002.paragraph') }}</p>

        <VueCodeMirror ref="codeMirrorComponent" value="Authorization: Bearer <<Your_ApiKey>>" :options="editorOptions" />
      </CCardBody>

      <CCardBody class="">
        <p>{{ $t('api.documentation.api-key.002.paragraph-2') }}</p>

        <VueCodeMirror ref="codeMirrorComponent" :value="cURLApi" :options="editorOptions" />
      </CCardBody>
    </CCard>

    <!-- sms-->
    <CCard :ref="pageSections.TransactionalSMS">
      <CCardHeader class="">
        <h2 class="mb-2">{{ $t('api.documentation.sms.titlePage') }}</h2>
      </CCardHeader>
      <!-- 
      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.sms.001.title') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <p>{{ $t('api.documentation.sms.001.paragraph') }}</p>
      </CCardBody>

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.sms.002.title') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <p>{{ $t('api.documentation.sms.002.paragraph') }}</p>
      </CCardBody> -->

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.sms.003.title') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <h5 class="mb-2">{{ $t('api.documentation.sms.003.subtitle') }}</h5>
        <p>{{ $t('api.documentation.sms.003.paragraph') }}</p>
      </CCardBody>

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.sms.004.title') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <p>{{ $t('api.documentation.sms.004.paragraph') }}</p>
      </CCardBody>

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.sms.005.title') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <p>
          <a href="#" @click.prevent="goto('transactional-api-authentication')">{{ $t('api.documentation.sms.005.paragraph') }}</a>
        </p>
      </CCardBody>

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.sms.007.title') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <h4 class="mb-2">{{ $t('api.documentation.sms.007.subtitle-001') }}</h4>
        <CAlert color="success mb-0">
          <CBadge color="success text-uppercase padding-3 mr-3">POST</CBadge>
          <code class="text-gray-700 font-md">{{ $t('api.documentation.sms.007.paragraph') }}</code>
        </CAlert>
      </CCardBody>

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.sms.007.subtitle-003') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <table class="table">
          <thead>
            <tr>
              <td>{{ $t('api.documentation.sms.007.table.header.001') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.header.002') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.header.003') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.header.004') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.header.005') }}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ $t('api.documentation.sms.007.table.line-001.001') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-001.002') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-001.003') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-001.004') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-001.005') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.007.table.line-002.001') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-002.002') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-002.003') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-002.004') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-002.005') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.007.table.line-003.001') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-003.002') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-003.003') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-003.004') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-003.005') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.007.table.line-004.001') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-004.002') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-004.003') }}</td>
              <td>
                <ul class="p-0">
                  <li>{{ $t('api.documentation.sms.007.table.line-004.004.items.001') }}</li>
                  <li>{{ $t('api.documentation.sms.007.table.line-004.004.items.002') }}</li>
                </ul>
              </td>
              <td>{{ $t('api.documentation.sms.007.table.line-004.005') }}</td>
            </tr>

            <tr>
              <td>{{ $t('api.documentation.sms.007.table.line-005.001') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-005.002') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-005.003') }}</td>
              <td>
                <ul class="p-0">
                  <li>{{ $t('api.documentation.sms.007.table.line-005.004.items.001') }}</li>
                  <li>{{ $t('api.documentation.sms.007.table.line-005.004.items.002') }}</li>
                </ul>
              </td>
              <td>{{ $t('api.documentation.sms.007.table.line-005.005') }}</td>
            </tr>

            <tr>
              <td>{{ $t('api.documentation.sms.007.table.line-006.001') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-006.002') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-006.003') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-006.004') }}</td>
              <td>{{ $t('api.documentation.sms.007.table.line-006.005') }}</td>
            </tr>
          </tbody>
        </table>
      </CCardBody>

      <CCardHeader class="">
        <h5 class="mb-2">{{ $t('api.documentation.sms.007.subtitle-002') }}</h5>
      </CCardHeader>

      <CCardBody class="">
        <VueCodeMirror ref="codeMirrorComponent" v-model="smsPostSend" :options="editorOptions" />
      </CCardBody>

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.sms.008.title') }}</h4>
      </CCardHeader>
      
      <CCardBody class="">
        <table class="table">
          <thead>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.header.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.header.002') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.header.003') }}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-001.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-001.002') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-001.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-002.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-002.002') }}</td>
              <td>
                {{ $t('api.documentation.sms.008.table.line-002.003.description') }}
                <ul class="p-0">
                  <li>{{ $t('api.documentation.sms.008.table.line-002.003.items.001') }}</li>
                  <li>{{ $t('api.documentation.sms.008.table.line-002.003.items.002') }}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-003.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-003.002') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-003.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-004.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-004.002') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-004.003') }}</td>
            </tr>

            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-005.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-005.002') }}</td>
              <td>
                {{ $t('api.documentation.sms.008.table.line-005.003.description') }}
                <ul class="p-0">
                  <li>{{ $t('api.documentation.sms.008.table.line-005.003.items.001') }}</li>
                  <li>{{ $t('api.documentation.sms.008.table.line-005.003.items.002') }}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-006.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-006.002') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-006.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-007.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-007.002') }}</td>
              <td>
                {{ $t('api.documentation.sms.008.table.line-005.003.description') }}
                <ul class="p-0">
                  <li>{{ $t('api.documentation.sms.008.table.line-007.003.items.001') }}</li>
                  <li>{{ $t('api.documentation.sms.008.table.line-007.003.items.002') }}</li>
                  <li>{{ $t('api.documentation.sms.008.table.line-007.003.items.003') }}</li>
                  <li>{{ $t('api.documentation.sms.008.table.line-007.003.items.004') }}</li>
                  <li>{{ $t('api.documentation.sms.008.table.line-007.003.items.005') }}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-008.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-008.002') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-008.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-009.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-009.002') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-009.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-010.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-010.002') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-010.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-011.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-011.002') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-011.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-012.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-012.002') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-012.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-013.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-013.002') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-013.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-014.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-014.002') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-014.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.sms.008.table.line-015.001') }}</td>
              <td>{{ $t('api.documentation.sms.008.table.line-015.002') }}</td>
              <td>
                <div v-html="$t('api.documentation.sms.008.table.line-015.003')"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </CCardBody>

      <CCardHeader class="">
        <h5 class="mb-2">{{ $t('api.documentation.sms.008.title2') }}</h5>
        <h6>{{ $t('api.documentation.sms.008.subtitle-001') }}</h6>
      </CCardHeader>

      <CCardBody class="">
        <VueCodeMirror ref="codeMirrorComponent" v-model="generalError" :options="editorOptions" />
      </CCardBody>

      <CCardHeader class="">
        <h6>{{ $t('api.documentation.sms.008.subtitle-002') }}</h6>
      </CCardHeader>

      <CCardBody class="">
        <VueCodeMirror ref="codeMirrorComponent" v-model="parameterizationSMS" :options="editorOptions" />
      </CCardBody>

      <CCardHeader class="">
        <h6>{{ $t('api.documentation.sms.008.subtitle-003') }}</h6>
      </CCardHeader>

      <CCardBody class="">
        <VueCodeMirror ref="codeMirrorComponent" v-model="successEmail" :options="editorOptions" />
      </CCardBody>

      <CCardHeader class="">
        <h6>{{ $t('api.documentation.sms.008.subtitle-004') }}</h6>
      </CCardHeader>

      <CCardBody class="">
        <ul>
          <li>{{ $t('api.documentation.sms.008.listHttp.001') }}</li>
          <li>{{ $t('api.documentation.sms.008.listHttp.002') }}</li>
          <li>{{ $t('api.documentation.sms.008.listHttp.003') }}</li>
          <li>{{ $t('api.documentation.sms.008.listHttp.004') }}</li>
        </ul>
      </CCardBody>
    </CCard>

    <!-- email-->
    <CCard :ref="pageSections.TransactionalEmail">
      <CCardHeader class="">
        <h2 class="mb-2">{{ $t('api.documentation.email.titlePage') }}</h2>
      </CCardHeader>

      <!-- <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.email.001.title') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <p>{{ $t('api.documentation.email.001.paragraph') }}</p>
      </CCardBody>

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.email.002.title') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <p>{{ $t('api.documentation.email.002.paragraph') }}</p>
      </CCardBody> -->

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.email.003.title') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <h5 class="mb-2">{{ $t('api.documentation.email.003.subtitle') }}</h5>
        <p>{{ $t('api.documentation.email.00.paragraph') }}</p>
      </CCardBody>

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.email.004.title') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <p>{{ $t('api.documentation.email.004.paragraph') }}</p>
      </CCardBody>

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.email.005.title') }}</h4>
      </CCardHeader>
      <CCardBody class="">
        <p>
          <a href="#" @click.prevent="goto('transactional-api-authentication')">{{ $t('api.documentation.email.005.paragraph') }}</a>
        </p>
      </CCardBody>

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.email.007.title') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <h4 class="mb-2">{{ $t('api.documentation.email.007.subtitle-001') }}</h4>
        <CAlert color="success mb-0">
          <CBadge color="success text-uppercase padding-3 mr-3">POST</CBadge>
          <code class="text-gray-700 font-md">{{ $t('api.documentation.email.007.paragraph') }}</code>
        </CAlert>
      </CCardBody>

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.email.007.subtitle-003') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <table class="table">
          <thead>
            <tr>
              <td>{{ $t('api.documentation.email.007.table.header.001') }}</td>
              <td>{{ $t('api.documentation.email.007.table.header.002') }}</td>
              <td>{{ $t('api.documentation.email.007.table.header.003') }}</td>
              <td>{{ $t('api.documentation.email.007.table.header.004') }}</td>
              <td>{{ $t('api.documentation.email.007.table.header.005') }}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ $t('api.documentation.email.007.table.line-001.001') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-001.002') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-001.003') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-001.004') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-001.005') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.007.table.line-002.001') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-002.002') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-002.003') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-002.004') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-002.005') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.007.table.line-003.001') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-003.002') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-003.003') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-003.004') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-003.005') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.007.table.line-004.001') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-004.002') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-004.003') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-004.004') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-004.005') }}</td>
            </tr>

            <tr>
              <td>{{ $t('api.documentation.email.007.table.line-005.001') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-005.002') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-005.003') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-005.004') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-005.005') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.007.table.line-006.001') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-006.002') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-006.003') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-006.004') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-006.005') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.007.table.line-007.001') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-007.002') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-007.003') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-007.004') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-007.005') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.007.table.line-008.001') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-008.002') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-008.003') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-008.004') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-008.005') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.007.table.line-009.001') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-009.002') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-009.003') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-009.004') }}</td>
              <td>{{ $t('api.documentation.email.007.table.line-009.005') }}</td>
            </tr>
          </tbody>
        </table>
      </CCardBody>

      <CCardHeader class="">
        <h5 class="mb-2">{{ $t('api.documentation.email.007.subtitle-002') }}</h5>
      </CCardHeader>

      <CCardBody class="">
        <VueCodeMirror ref="codeMirrorComponent" v-model="emailPostSend" :options="editorOptions" />
      </CCardBody>

      <CCardHeader class="">
        <h4 class="mb-2">{{ $t('api.documentation.email.008.title') }}</h4>
      </CCardHeader>

      <CCardBody class="">
        <table class="table">
          <thead>
            <tr>
              <td>{{ $t('api.documentation.email.008.table.header.001') }}</td>
              <td>{{ $t('api.documentation.email.008.table.header.002') }}</td>
              <td>{{ $t('api.documentation.email.008.table.header.003') }}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ $t('api.documentation.email.008.table.line-001.001') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-001.002') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-001.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.008.table.line-002.001') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-002.002') }}</td>
              <td>
                {{ $t('api.documentation.email.008.table.line-002.003.description') }}
                <ul class="p-0">
                  <li>{{ $t('api.documentation.email.008.table.line-002.003.items.001') }}</li>
                  <li>{{ $t('api.documentation.email.008.table.line-002.003.items.002') }}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.008.table.line-003.001') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-003.002') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-003.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.008.table.line-004.001') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-004.002') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-004.003') }}</td>
            </tr>

            <tr>
              <td>{{ $t('api.documentation.email.008.table.line-005.001') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-005.002') }}</td>
              <td>
                {{ $t('api.documentation.email.008.table.line-005.003.description') }}
                <ul class="p-0">
                  <li>{{ $t('api.documentation.email.008.table.line-005.003.items.001') }}</li>
                  <li>{{ $t('api.documentation.email.008.table.line-005.003.items.002') }}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.008.table.line-006.001') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-006.002') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-006.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.008.table.line-007.001') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-007.002') }}</td>
              <td>
                {{ $t('api.documentation.email.008.table.line-005.003.description') }}
                <ul class="p-0">
                  <li>{{ $t('api.documentation.email.008.table.line-007.003.items.001') }}</li>
                  <li>{{ $t('api.documentation.email.008.table.line-007.003.items.002') }}</li>
                  <li>{{ $t('api.documentation.email.008.table.line-007.003.items.003') }}</li>
                  <li>{{ $t('api.documentation.email.008.table.line-007.003.items.004') }}</li>
                  <li>{{ $t('api.documentation.email.008.table.line-007.003.items.005') }}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.008.table.line-008.001') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-008.002') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-008.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.008.table.line-009.001') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-009.002') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-009.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.008.table.line-010.001') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-010.002') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-010.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.008.table.line-011.001') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-011.002') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-011.003') }}</td>
            </tr>
            <tr>
              <td>{{ $t('api.documentation.email.008.table.line-012.001') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-012.002') }}</td>
              <td>{{ $t('api.documentation.email.008.table.line-012.003') }}</td>
            </tr>
          </tbody>
        </table>
      </CCardBody>

      <CCardHeader class="">
        <h5 class="mb-2">{{ $t('api.documentation.email.008.title2') }}</h5>
        <h6>{{ $t('api.documentation.email.008.subtitle-001') }}</h6>
      </CCardHeader>

      <CCardBody class="">
        <VueCodeMirror ref="codeMirrorComponent" v-model="generalErrorEmail" :options="editorOptions" />
      </CCardBody>

      <CCardHeader class="">
        <h6>{{ $t('api.documentation.email.008.subtitle-002') }}</h6>
      </CCardHeader>

      <CCardBody class="">
        <VueCodeMirror ref="codeMirrorComponent" v-model="parameterizationEmail" :options="editorOptions" />
      </CCardBody>

      <CCardHeader class="">
        <h6>{{ $t('api.documentation.email.008.subtitle-003') }}</h6>
      </CCardHeader>

      <CCardBody class="">
        <VueCodeMirror ref="codeMirrorComponent" v-model="successEmail" :options="editorOptions" />
      </CCardBody>

      <CCardHeader class="">
        <h6>{{ $t('api.documentation.email.008.subtitle-004') }}</h6>
      </CCardHeader>

      <CCardBody class="">
        <ul>
          <li>{{ $t('api.documentation.email.008.listHttp.001') }}</li>
          <li>{{ $t('api.documentation.email.008.listHttp.002') }}</li>
          <li>{{ $t('api.documentation.email.008.listHttp.003') }}</li>
          <li>{{ $t('api.documentation.email.008.listHttp.004') }}</li>
        </ul>
      </CCardBody>
    </CCard>
  </section>
</template>

<script>
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/eclipse.css'
import 'codemirror/mode/javascript/javascript'
import { pageSections } from './constants'

export default {
  name: 'DocumentationsContent',
  components: {
    VueCodeMirror: codemirror,
  },
  data() {
    return {
      scrolledByClick: false,
      pageSections: pageSections,
      generalError: `{
  "error": {
    "code": "INSUFFICIENT_BALANCE",
    "description": "description"
  }
}`,

      parameterizationSMS: `{
  "messages": [
    {
      "error": {
        "code": "PARAM_INVALID",
        "param": "FieldName",
        "description": "description"
      }
    }
  ]
}`,

      successSMS: `{
  "messages": [
    {
      "status": "SUCCESS",
      "messageId": "04eda20a-e05a-4a05-8b4c-696a9f2af6ac",
      "segmentCount": 1
      "encoding": "GSM-7bit",
      "cost":
      {
        "amount": 1,
        "countryCode": "PT"
      }
    }
  ]
}`,

      smsPostSend: `{
  organizationId: "${this.$store.state.auth.organizationId}",
  messages: [{
    text: "text",
    to: "351911111111",
    from: "<<Sender>>",
    expirationDateTime: "2022-10-10 09:00"
  }]
}`,
      emailPostSend: `{
  organizationId: "${this.$store.state.auth.organizationId}",
  messages: [{
    to: "to@email.com",
    from: "from@email.com",
    displayName: "displayName",
    subject: "subject",
    expirationDateTime: "2022-10-10 09:00",
    textContent: "text",
    htmlContent: "htmlContent"
  }]
}`,

      generalErrorEmail: `{
  "error": {
    "code": "INSUFFICIENT_BALANCE",
    "description": "description"
  }
}`,

      parameterizationEmail: `{
  "messages": [
    {
      "error": {
        "code": "PARAM_INVALID",
        "param": "FieldName",
        "description": "description"
      }
    }
  ]
}`,

      successEmail: `{
  "messages": [
    {
      "status": "SUCCESS",
      "messageId": "04eda20a-e05a-4a05-8b4c-696a9f2af6ac",
      "segmentCount": 1
      "encoding": "GSM-7bit",
      "cost": {
        "amount": 1,
        "countryCode": "PT"
      }
    }
  ]
}`,

      cURLApi: `curl
--header 'Authorization: Bearer <<Your_ApiKey>>
--header 'Content-Type: application/json'
--data-raw '{
  "OrganizationId": "${this.$store.state.auth.organizationId}",
  "Messages": [{
    "To": "to@email.com",
    "From": "sender@email.com",
    "DisplayName": "Sender",
    "Subject": "Subject",
    "ExpirationDateTime": "2022-01-01 12:00:00",
    "TextContent": "Content in simple text",
    "HtmlContent": "Content in <strong>HTML</strong> text"
  }]
}' \
-X POST https://api.arpoone.com/v1.0/email/send`,
    }
  },
  computed: {
    codemirrorInstance() {
      return this.$refs.codeMirrorComponent.codemirror
    },
    editorOptions() {
      return {
        tabSize: 2,
        styleActiveLine: true,
        lineNumbers: true,
        lineWrapping: true,
        line: true,
        height: 'auto',
        mode: 'javascript',
        theme: 'eclipse',
        autofocus: true,
        fontSize: 12,
      }
    },
  },
  methods: {
    goto(refName) {
      debugger
      var element = this.$refs[refName]
      var top = element.offsetTop

      window.scrollTo(0, top)
    },
    async scrollClick(el) {
      this.scrolledByClick = true
      const sectionElement = this.$refs[el]

      sectionElement.scrollIntoView({ behavior: 'smooth' })

      // TODO: solução temporária para evitar mudança de estado por dois eventos
      const delay = 1500
      setTimeout(() => {
        this.scrolledByClick = false
      }, delay)
      this.$emit('sectionChange', el)
    },
    handleScroll() {
      if (this.scrolledByClick) return

      const apiKeySection = this.$refs[pageSections.APIKey]
      const transactionalSMSSection = this.$refs[pageSections.TransactionalSMS]
      const transactionalEmailSection = this.$refs[pageSections.TransactionalEmail]
      const scrollPosition = window.scrollY

      if (scrollPosition >= apiKeySection.offsetTop && scrollPosition < transactionalSMSSection.offsetTop) {
        this.$emit('sectionChange', pageSections.APIKey)
      } else if (scrollPosition >= transactionalSMSSection.offsetTop && scrollPosition < transactionalEmailSection.offsetTop) {
        this.$emit('sectionChange', pageSections.TransactionalSMS)
      } else if (scrollPosition >= transactionalEmailSection.offsetTop) {
        this.$emit('sectionChange', pageSections.TransactionalEmail)
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>

<style lang="scss" scoped>
.card-body .CodeMirror {
  height: auto;
}

.highlight__text {
  h4 {
    color: #8a2100;
  }

  padding: 2%;
  background: #fff7f5;
  border-left: 3px solid var(--primary);
}
</style>

<style lang="scss" scoped>
.card {
  padding: 2% 1.5%;

  p {
    line-height: 2rem;
  }

  .table {
    thead {
      background: var(--gray-200);
    }

    td {
      border: 1px solid var(--gray-300);
    }
  }
}

.list-group-item {
  border-color: transparent;
}

.vue-codemirror {
  font-size: 12px;
  pointer-events: none;
}

.card-header {
  border: none;
}
</style>
